<micro-lookup domain="auth" obj="contactsByEmail" [key]="contactId"></micro-lookup>
